var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirculatingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81466 7.92249V10.3275C9.81466 12.3555 7.92316 14 5.58964 14C3.25613 14 1.36462 12.3555 1.36462 10.3275V7.92249C1.36462 9.9505 3.25613 11.4 5.58964 11.4C7.92316 11.4 9.81466 9.9505 9.81466 7.92249Z",
    stroke: "#C9CBCD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81466 4.67252C9.81466 5.26402 9.65216 5.81002 9.36616 6.27803C8.67066 7.42203 7.24065 8.15004 5.58964 8.15004C3.93864 8.15004 2.50863 7.42203 1.81313 6.27803C1.52712 5.81002 1.36462 5.26402 1.36462 4.67252C1.36462 3.65851 1.83913 2.74201 2.59963 2.07901C3.36663 1.4095 4.41964 1 5.58964 1C6.75965 1 7.81266 1.4095 8.57966 2.07251C9.34016 2.74201 9.81466 3.65851 9.81466 4.67252Z",
    stroke: "#C9CBCD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81466 4.67252V7.92253C9.81466 9.95054 7.92316 11.4001 5.58964 11.4001C3.25613 11.4001 1.36462 9.95054 1.36462 7.92253V4.67252C1.36462 2.64451 3.25613 1 5.58964 1C6.75965 1 7.81266 1.4095 8.57966 2.07251C9.34016 2.74201 9.81466 3.65851 9.81466 4.67252Z",
    stroke: "#C9CBCD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculatingIcon);
export default __webpack_public_path__ + "static/media/circulating-icon.863abd5f881f3e89fc914d54259074ce.svg";
export { ForwardRef as ReactComponent };